module.exports = __webpack_public_path__ + "../static/media/TitilliumWeb-Regular.4f5848e6.ttf";